import { Block } from '@chilipiper/api-type-def'

export enum FieldType {
  Email = 'Email',
  Multiline = 'Multiline',
  MultipleSelection = 'MultipleSelection',
  Number = 'Number',
  Phone = 'Phone',
  PhysicalAddress = 'PhysicalAddress',
  Select = 'Select',
  SingleLine = 'SingleLine',
  SingleSelection = 'SingleSelection',
}

export interface Field extends Block {
  contactField?: string
  fieldType: FieldType
  id: string
  index: number
  label: string
  leadField?: string
  optionsType?: OptionsType
}

export enum OptionsType {
  CRM = 'CRM',
  Custom = 'Custom',
  None = 'None',
}
